<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{ "title.enterprise_action_log" | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel
        expanded="true"
        class="mt-3"
        *ngIf="(userType !== -1 && userType !== 2) || checkDisplayFullList()"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "enterprise_customer_management.ttl_search" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form
          #f="ngForm"
          (ngSubmit)="onFilterCustomers(0, paginate.pageSize)"
          class="pb-3"
        >
          <div class="row">
            <div class="col-lg-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    enterpriseActionLog.account =
                      enterpriseActionLog.account == undefined
                        ? ''
                        : (enterpriseActionLog.account + '').trim()
                  "
                  #focusInput
                  matInput
                  type="text"
                  [placeholder]="'enterprise_action_log.account' | translate"
                  name="account"
                  [(ngModel)]="enterpriseActionLog.account"
                  maxlength="200"
                  autocomplete="off"
                />
                <button
                  mat-button
                  *ngIf="enterpriseActionLog.account"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="enterpriseActionLog.account = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="
                    enterpriseActionLog.action =
                      enterpriseActionLog.action == undefined
                        ? ''
                        : (enterpriseActionLog.action + '').trim()
                  "
                  #focusInput
                  matInput
                  type="text"
                  [placeholder]="'enterprise_action_log.action' | translate"
                  name="action"
                  [(ngModel)]="enterpriseActionLog.action"
                  maxlength="200"
                  autocomplete="off"
                />
                <button
                  mat-button
                  *ngIf="enterpriseActionLog.action"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="enterpriseActionLog.action = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <ng-container *ngIf="!isBasicSearchForm" class="row col-lg-12">
              <div class="col-lg-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="
                      enterpriseActionLog.deviceType =
                        enterpriseActionLog.deviceType == undefined
                          ? ''
                          : (enterpriseActionLog.deviceType + '').trim()
                    "
                    matInput
                    type="text"
                    [placeholder]="
                      'enterprise_action_log.device_type' | translate
                    "
                    name="deviceType"
                    [(ngModel)]="enterpriseActionLog.deviceType"
                    maxlength="200"
                    autocomplete="off"
                  />
                  <button
                    mat-button
                    *ngIf="enterpriseActionLog.deviceType"
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="enterpriseActionLog.deviceType = ''"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="col-lg-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="
                      enterpriseActionLog.errorCode =
                        enterpriseActionLog.errorCode == undefined
                          ? ''
                          : (enterpriseActionLog.errorCode + '').trim()
                    "
                    matInput
                    type="text"
                    [placeholder]="
                      'enterprise_action_log.error_code' | translate
                    "
                    name="errorCode"
                    [(ngModel)]="enterpriseActionLog.errorCode"
                    maxlength="200"
                    autocomplete="off"
                  />
                  <button
                    mat-button
                    *ngIf="enterpriseActionLog.errorCode"
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="enterpriseActionLog.errorCode = ''"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="col-lg-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="
                      enterpriseActionLog.errorDescription =
                        enterpriseActionLog.errorDescription == undefined
                          ? ''
                          : (enterpriseActionLog.errorDescription + '').trim()
                    "
                    matInput
                    type="text"
                    [placeholder]="
                      'enterprise_action_log.error_description' | translate
                    "
                    name="errorDescription"
                    [(ngModel)]="enterpriseActionLog.errorDescription"
                    maxlength="200"
                    autocomplete="off"
                  />
                  <button
                    mat-button
                    *ngIf="enterpriseActionLog.errorDescription"
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="enterpriseActionLog.errorDescription = ''"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <!-- Thời điểm xảy ra (từ ngày) -->
              <!-- <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{ 'enterprise_action_log.created_date_from' | translate }}</mat-label>
                  <input matInput [matDatepicker]="createdTimeFrom" [max]="enterpriseActionLog.createdTimeTo"
                         #createdTimeFromCtrl="ngModel"
                         (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['createdTimeFrom'])"
                         name="createdTimeFrom" #pickerInput [(ngModel)]="enterpriseActionLog.createdTimeFrom" maxlength="200"
                         (focus)="createdDateErr = 'fromDate'" autocomplete="off"/>
                  <mat-datepicker-toggle matSuffix [for]="createdTimeFrom">
                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                       [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                  </mat-datepicker-toggle>
                  <mat-datepicker #createdTimeFrom></mat-datepicker>
                  <mat-error *ngIf="createdTimeFromCtrl?.errors?.matDatepickerParse">
                    {{'validation.format_of_date' | translate}}
                  </mat-error>
                  <mat-error *ngIf="createdTimeFromCtrl?.errors?.matDatepickerMax && createdDateErr == 'fromDate'">
                    {{ 'enterprise_action_log.created_date_from' | translate }}
                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                    {{ 'enterprise_action_log.created_date_to' | translate }}
                  </mat-error>
                </mat-form-field>
              </div> -->

              <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{
                    "enterprise_action_log.created_date_from" | translate
                  }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="createdTimeFrom"
                    [max]="enterpriseActionLog.createdTimeTo"
                    #createdTimeFromCtrl="ngModel"
                    (change)="
                      this.commonService.resetDatePicker(
                        pickerInput.value,
                        this.ngForm.controls['createdTimeFrom']
                      )
                    "
                    name="createdTimeFrom"
                    #pickerInput
                    [(ngModel)]="enterpriseActionLog.createdTimeFrom"
                    maxlength="200"
                    (focus)="createdDateErr = 'fromDate'"
                    autocomplete="off"
                  />
                  <mat-datepicker-toggle matSuffix [for]="createdTimeFrom">
                    <i
                      matDatepickerToggleIcon
                      class="fa fa-calendar"
                      aria-hidden="true"
                      [matTooltip]="
                        'enterprise_contract.tooltips.pick_date' | translate
                      "
                    ></i>
                  </mat-datepicker-toggle>
                  <mat-datepicker #createdTimeFrom></mat-datepicker>

                  <!-- Chỉ hiển thị lỗi định dạng nếu có giá trị và sai định dạng -->
                  <mat-error
                    *ngIf="
                      createdTimeFromCtrl?.errors?.matDatepickerParse &&
                      pickerInput.value
                    "
                  >
                    {{ "validation.format_of_date" | translate }}
                  </mat-error>

                  <!-- Chỉ hiển thị lỗi ngày lớn hơn ngày đến nếu có giá trị -->
                  <mat-error
                    *ngIf="
                      createdTimeFromCtrl?.errors?.matDatepickerMax &&
                      createdDateErr == 'fromDate' &&
                      pickerInput.value
                    "
                  >
                    {{ "enterprise_action_log.created_date_from" | translate }}
                    {{
                      "validation.from_date_smaller_than_or_equal_to_date"
                        | translate
                    }}
                    {{ "enterprise_action_log.created_date_to" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- Thời điểm xảy ra (đến ngày) -->
              <!-- <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{ 'enterprise_action_log.created_date_to' | translate }}</mat-label>
                  <input matInput [matDatepicker]="createdTimeToRef" [min]="enterpriseActionLog.createdTimeFrom"
                         (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['createdTimeTo'])"
                         name="createdTimeTo" #pickerInput1 [(ngModel)]="enterpriseActionLog.createdTimeTo"
                         #createdTimeToCtrl="ngModel"
                         maxlength="200" (focus)="createdDateErr = 'toDate'" autocomplete="off"/>
                  <mat-datepicker-toggle matSuffix [for]="createdTimeToRef">
                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                       [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                  </mat-datepicker-toggle>
                  <mat-datepicker #createdTimeToRef></mat-datepicker>
                  <mat-error *ngIf="createdTimeToCtrl?.errors?.matDatepickerParse">
                    {{'validation.format_of_date' | translate}}
                  </mat-error>
                  <mat-error *ngIf="createdTimeToCtrl?.errors?.matDatepickerMin && createdDateErr == 'toDate'">
                    {{ 'search_form.created_date_to' | translate }}
                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                    {{ 'search_form.created_date_from' | translate }}
                  </mat-error>
                </mat-form-field>
              </div> -->

              <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{
                    "enterprise_action_log.created_date_to" | translate
                  }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="createdTimeToRef"
                    [min]="enterpriseActionLog.createdTimeFrom"
                    (change)="
                      this.commonService.resetDatePicker(
                        pickerInput1.value,
                        this.ngForm.controls['createdTimeTo']
                      )
                    "
                    name="createdTimeTo"
                    #pickerInput1
                    [(ngModel)]="enterpriseActionLog.createdTimeTo"
                    #createdTimeToCtrl="ngModel"
                    maxlength="200"
                    (focus)="createdDateErr = 'toDate'"
                    autocomplete="off"
                  />
                  <mat-datepicker-toggle matSuffix [for]="createdTimeToRef">
                    <i
                      matDatepickerToggleIcon
                      class="fa fa-calendar"
                      aria-hidden="true"
                      [matTooltip]="
                        'enterprise_contract.tooltips.pick_date' | translate
                      "
                    ></i>
                  </mat-datepicker-toggle>
                  <mat-datepicker #createdTimeToRef></mat-datepicker>

                  <!-- Only show format error if there's a value and it's invalid -->
                  <mat-error
                    *ngIf="
                      createdTimeToCtrl?.errors?.matDatepickerParse &&
                      pickerInput1.value
                    "
                  >
                    {{ "validation.format_of_date" | translate }}
                  </mat-error>

                  <!-- Only show min date error if there's a value and it's invalid -->
                  <mat-error
                    *ngIf="
                      createdTimeToCtrl?.errors?.matDatepickerMin &&
                      createdDateErr == 'toDate' &&
                      pickerInput1.value
                    "
                  >
                    {{ "search_form.created_date_to" | translate }}
                    {{
                      "validation.to_date_larger_than_or_equal_from_date"
                        | translate
                    }}
                    {{ "search_form.created_date_from" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-lg-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="
                      enterpriseActionLog.ip =
                        enterpriseActionLog.ip == undefined
                          ? ''
                          : (enterpriseActionLog.ip + '').trim()
                    "
                    matInput
                    type="text"
                    [placeholder]="
                      'enterprise_action_log.ip_address' | translate
                    "
                    name="ip"
                    [(ngModel)]="enterpriseActionLog.ip"
                    maxlength="200"
                    autocomplete="off"
                  />
                  <button
                    mat-button
                    *ngIf="enterpriseActionLog.ip"
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="enterpriseActionLog.ip = ''"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="col-lg-4">
                <mat-form-field class="w-100">
                  <input
                    (focusout)="
                      enterpriseActionLog.objectAction =
                        enterpriseActionLog.objectAction == undefined
                          ? ''
                          : (enterpriseActionLog.objectAction + '').trim()
                    "
                    matInput
                    type="text"
                    [placeholder]="
                      'enterprise_action_log.object_action' | translate
                    "
                    name="objectAction"
                    [(ngModel)]="enterpriseActionLog.objectAction"
                    maxlength="200"
                    autocomplete="off"
                  />
                  <button
                    mat-button
                    *ngIf="enterpriseActionLog.objectAction"
                    type="button"
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="enterpriseActionLog.objectAction = ''"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div class="col-xl-3 col-lg-4 col-md-6">
                <mat-form-field class="w-100">
                  <mat-select
                    class="form-value-default"
                    #focusInput
                    placeholder="Trạng thái"
                    name="confirmStatus"
                    [(ngModel)]="enterpriseActionLog.status"
                  >
                    <mat-option value="">-- Tất cả --</mat-option>
                    <mat-option [value]="true">Thành công</mat-option>
                    <mat-option [value]="false">Thất bại</mat-option>
                  </mat-select>
                  <!-- <button mat-button *ngIf="enterpriseActionLog.status !== ''" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="enterpriseActionLog.status=''">
                                    <mat-icon>close</mat-icon>
                                </button> -->
                </mat-form-field>
              </div>
            </ng-container>
            <!-- button up/down -->
            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button
                *ngIf="!isBasicSearchForm"
                type="button"
                mat-button
                class="advance-search"
                (click)="onCloseAdvancedSearchForm()"
              >
                <span>{{
                  "enterprise_contract.buttons.basic" | translate
                }}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button
                *ngIf="isBasicSearchForm"
                type="button"
                mat-button
                class="advance-search"
                (click)="onExpandAdvancedSearchForm()"
              >
                <span>{{
                  "enterprise_contract.buttons.advance" | translate
                }}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <button
                mat-stroked-button
                color="primary"
                type="submit"
                (click)="onClickBtnFilter()"
              >
                <mat-icon class="mr-0" style="font-weight: 900"
                  >search</mat-icon
                >
                {{
                  "enterprise_customer_management.buttons.search" | translate
                }}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
      <mat-expansion-panel
        expanded="true"
        *ngIf="userType == 2 && !checkDisplayFullList()"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "enterprise_customer_management.ttl_search" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="onFilterCustomers(0, paginate.pageSize)">
          <div class="row">
            <div class="col-lg-4 d-flex justify-content-center">
              <div class="w-100 center-vertical">
                <button
                  mat-stroked-button
                  color="primary"
                  type="submit"
                  (click)="onClickBtnFilter()"
                >
                  <mat-icon class="mr-0" style="font-weight: 900"
                    >search</mat-icon
                  >
                  {{
                    "enterprise_customer_management.buttons.search" | translate
                  }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Danh sách log -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title
          class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center"
        >
          <span *ngIf="!commonService.getIsLockedEnterprise()"
            >{{
              "enterprise_action_log.list_enterprise_action_log" | translate
            }}
            ({{ paginate.totalRow }})
          </span>
          <span *ngIf="commonService.getIsLockedEnterprise()"
            >{{
              "enterprise_customer_management.list_customer" | translate
            }}
            ({{ paginate.totalRow }})
          </span>
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource" width="100%">
            <ng-container matColumnDef="id">
              <mat-header-cell
                *matHeaderCellDef
                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
              >
                {{
                  "enterprise_customer_management.table_headers.No" | translate
                }}</mat-header-cell
              >
              <mat-cell
                *matCellDef="let element"
                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
              >
                {{
                  paginate.no[dataSource.filteredData.indexOf(element)]
                }}</mat-cell
              >
            </ng-container>

            <ng-container matColumnDef="account">
              <mat-header-cell
                *matHeaderCellDef
                style="width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ "enterprise_action_log.account" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                matTooltip="{{ element.account }}"
                matTooltipPosition="below"
                style="width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                <span class="fix-width">{{ element.account }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell
                *matHeaderCellDef
                style="width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ "enterprise_action_log.action" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                matTooltip="{{ element.action }}"
                matTooltipPosition="below"
                style="width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                <span class="fix-width">{{ element.action }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="deviceType">
              <mat-header-cell
                *matHeaderCellDef
                style="width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ "enterprise_action_log.device_type" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                matTooltip="{{ element.deviceType }}"
                matTooltipPosition="below"
                style="width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                <span class="fix-width">{{ element.deviceType }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="errorCode">
              <mat-header-cell
                *matHeaderCellDef
                style="max-width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ "enterprise_action_log.error_code" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="max-width: 20%"
                class="mat-cell-non-boder-right-bottom"
                matTooltip="{{ element.errorCode }}"
              >
                <span class="fix-width">{{ element.errorCode }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="errorDescription">
              <mat-header-cell
                *matHeaderCellDef
                style="max-width: 20%"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ "enterprise_action_log.error_description" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="max-width: 20%"
                class="mat-cell-non-boder-right-bottom"
                matTooltip="{{ element.errorDescription }}"
              >
                <span class="fix-width">{{ element.errorDescription }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ip">
              <mat-header-cell
                *matHeaderCellDef
                style="max-width: 110px"
                class="mat-cell-non-boder-right-bottom"
              >
                {{ "enterprise_action_log.ip_address" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="max-width: 110px"
                matTooltip="{{ element.ip }}"
                class="mat-cell-non-boder-right-bottom number-cell-center"
              >
                <span class="fix-width">{{ element.ip }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="objectAction">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%">
                {{ "enterprise_action_log.object_action" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="max-width: 20%"
                matTooltip="{{ element.objectAction }}"
              >
                <span class="fix-width">{{ element.objectAction }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%">
                {{ "enterprise_action_log.status" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="max-width: 20%"
                matTooltip="{{ element.status }}"
              >
                <span class="fix-width">{{
                  getStatusView(element.status)
                }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%">
                {{ "enterprise_action_log.created_time" | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                style="max-width: 20%"
                matTooltip="{{ element.createdAt | dateformat }}"
              >
                <span class="fix-width">{{
                  element.createdAt | dateformat
                }}</span>
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
        <div class="py-4" *ngIf="error">
          <div class="card">
            <p
              class="card-body text-danger"
              style="white-space: pre-wrap; padding-bottom: 0"
            >
              {{ error }}
            </p>
          </div>
        </div>
        <!-- Pagination -->
        <app-pagination
          [(paginate)]="paginate"
          (pageChange)="onFilterCustomers($event.page, $event.pageSize)"
        >
        </app-pagination>
        <!-- /Pagination -->
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
